export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function normalizeImportedUserRow<
  T extends { email?: string | null; name?: string | null },
>(row: T): T {
  return {
    ...row,
    ...(row.email != null && row.email !== ""
      ? { email: normalizeEmail(row.email) }
      : {}),
    ...(row.name != null ? { name: row.name.trim() } : {}),
  };
}
